import React, { useEffect, useState } from "react";
import { BasePageModal } from "@/shared/components/modal/page-modal/base-page-modal";
import { useViewTrades } from "@/features/accounts/shared/hooks/use-view-trades";
import { HistoryInfo } from "@/features/accounts/shared/contexts/trades-context";

interface Props {
  accountGroupId: string;
  mlinkAccountId: string;
  mlinkId: string;
  passbookType: string;
  onTapCloseModal: () => void;
}

// 明細取込履歴モーダル
export const TradesHistoryModal= ({
  accountGroupId,
  mlinkAccountId,
  mlinkId,
  passbookType,
  onTapCloseModal
}: Props) => {

  const { getTradesHistory } = useViewTrades();
  const [tradesHistory, setTradesHistory] = useState<HistoryInfo[]>([]);
  const [hasMore, setHasMore] = useState(false);
  const [offset, setOffset] = useState(0);

  const loadHistory = async (nextOffset: number, append: boolean) => {
    // 履歴はサーバ側10件固定のため、offsetだけを指定して追加取得する。
    const res = await getTradesHistory(
      accountGroupId,
      mlinkAccountId,
      mlinkId,
      passbookType,
      String(nextOffset)
    );
    if (res?.data === undefined) {
      return;
    }
    setTradesHistory((current) => append ? [...current, ...res.data] : res.data);
    setHasMore(res.hasMore ?? false);
    setOffset(nextOffset + res.data.length);
  };

  useEffect(() => {
    loadHistory(0, false);
  }, []);

  const formatDate = (isoStr: string): string => {
    const date = new Date(isoStr);
    const y = date.getFullYear();
    const m = String(date.getMonth() + 1).padStart(2, '0');
    const d = String(date.getDate()).padStart(2, '0');
    const hh = String(date.getHours()).padStart(2, '0');
    const mm = String(date.getMinutes()).padStart(2, '0');

    return `${y}.${m}.${d} ${hh}:${mm}`;
  }

  const formatUpdateType = (type: number): string => {
    switch (type){
      case 0: return "自動"
      case 1: return "手動"
      default: return "-"
    }
  }

  const formatStatus = (status: number): string => {
    switch (status){
      case 0: return "成功"
      case 1: return "エラー"
      case 2: return "スキップ"
      case 3: return "警告"
      default: return "-"
    }
  }

  const formatDetails = (details: string): React.ReactNode => {
    return(
      <>
        {
          details.split('\n').map((line, index) => (
            <React.Fragment key={index}>
              {line}
              <br />
            </React.Fragment>
          ))
        }
      </>
    )
  }

  return (
    <BasePageModal
      title="取込履歴"
      className="md-list-history"
      handleClose={() => {
        onTapCloseModal();
      }}
    >
      <h2>このWeb明細帳内の取込履歴</h2>
      <div className="wrapper-table">
        <table className="history">
          <thead>
            <tr>
              <th>実行日時</th><th>方法</th><th>結果</th><th>利用者</th><th>詳細</th>
            </tr>
          </thead>
          <tbody>
            {tradesHistory.map((history, index) => (
              <tr key={`${history.executedAt}-${index}`}>
                <td>{formatDate(history.executedAt)}</td>
                <td>{formatUpdateType(history.updateType)}</td>
                <td>{formatStatus(history.status)}</td>
                <td>{history.user}</td>
                <td>{formatDetails(history.details)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {hasMore ? (
        <div className="history-load-more">
          <button type="button" onClick={() => loadHistory(offset, true)}>
            さらに表示
          </button>
        </div>
      ) : <></>}
    </BasePageModal>
  );
};
